import { z } from 'zod';

export const loginSchema = z.object({
  cpf: z.string({ message: 'Campo CPF é obrigatório' }),
  password: z.string({ message: 'Campo senha é obrigatório' }).min(6, 'Campo senha tem o mínimo de 6 caracteres'),
});

export type LoginValidationSchema = z.infer<typeof loginSchema>;

export const renewSessionSchema = loginSchema.pick({
  password: true,
});

export type RenewSessionValidationSchema = z.infer<typeof renewSessionSchema>;
